import { render, staticRenderFns } from "./buyLession.vue?vue&type=template&id=3da3235d&scoped=true"
import script from "./buyLession.vue?vue&type=script&lang=js"
export * from "./buyLession.vue?vue&type=script&lang=js"
import style0 from "./buyLession.vue?vue&type=style&index=0&id=3da3235d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da3235d",
  null
  
)

export default component.exports